// @mui
import {enUS, frFR, nlNL, ruRU, esES, deDE} from '@mui/material/locale';


// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Dutch',
    value: 'nl',
    systemValue: nlNL,
    icon: 'nl',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: 'gb',
  },
  {
    label: 'Français',
    value: 'fr',
    systemValue: frFR,
    icon: 'fr',
  },
  {
    label: 'Русский',
    value: 'ru',
    systemValue: ruRU,
    icon: 'ru',
  },
  {
    label: 'Español',
    value: 'es',
    systemValue: esES,
    icon: 'es',
  },
  {
    label: 'Deutsch',
    value: 'de',
    systemValue: deDE,
    icon: 'de',
  },

];

export const defaultLang = allLangs[0]; // English
